import { Connection } from "api/models/Connection";
import { PushOperation } from "api/models/PushOperation";

import { DataSet } from "../models/DataSet";
import { PublicApi } from "../publicApi";
import { PagedResponse } from "../shared";
import throwIfUndefined from "../throwIfUndefined";

export interface PublicService {
  getConnection: (
    companyId: string,
    connectionId: string
  ) => Promise<Connection>;
  getDataHistory: (
    companyId: string,
    pageNumber: number,
    pageSize: number
  ) => Promise<PagedResponse<DataSet>>;

  getPushOperations: (
    companyId: string,
    pageNumber: number,
    pageSize: number
  ) => Promise<PagedResponse<PushOperation>>;
}

export function makePublicService(api: PublicApi) {
  function getConnection(companyId: string, connectionId: string) {
    return api
      .getConnection(companyId, connectionId)
      .then((res) => throwIfUndefined(res, (d) => d?.data));
  }

  function getDataHistory(
    companyId: string,
    pageNumber: number,
    pageSize: number
  ) {
    return api
      .getDataHistory(companyId, pageNumber, pageSize)
      .then((res) => throwIfUndefined(res, (d) => d?.data))
      .catch((err) => {
        if (
          err.response?.request.status === 404 &&
          err.response.data.error.includes("Datasets not found for company")
        ) {
          return {
            pageNumber: 1,
            pageSize: 0,
            results: [] as DataSet[],
            totalResults: 0,
            _links: {
              current: { href: err.config.url },
              self: { href: err.config.url.split("?")[0] },
            },
          } as PagedResponse<DataSet>;
        }
        throw err;
      });
  }

  function getPushOperations(
    companyId: string,
    pageNumber: number,
    pageSize: number
  ) {
    return api
      .getPushOperations(companyId, pageNumber, pageSize)
      .then((res) => throwIfUndefined(res, (d) => d?.data));
  }

  return {
    getConnection,
    getDataHistory,
    getPushOperations,
  };
}
